import { jsx as _jsx } from "react/jsx-runtime";
import { Container } from '@emburse/embark-core';
export default function SingleColumnLayout({ children }) {
    return _jsx(Container, { style: { marginTop: 40, padding: 0 }, children: children });
}
